import React from 'react'
import PropTypes from 'prop-types'

import { Form as FinalForm } from 'react-final-form'
import { RailsForm } from '@support/RailsForm'

import Form from './Form'

const validate = values => {
  const errors = {}

  if (!values.variable) errors.variable = I18n.t('validations.required')
  if (!values.justification) errors.justification = I18n.t('validations.required')

  return errors
}

const Edit = ({ model, o }) => (
  <RailsForm
    component={FinalForm}
    action='update'
    url={`/v4/o/${o}/admin/equipment_measures/${model.id}`}
    successUrl={`/v4/o/${o}/admin/equipment_measures?equipment_id=${model.equipment_id || ''}&variable=${model.variable || ''}`}
    validate={validate}
    initialValues={model}
    render={(props) => (
      <Form
        title={I18n.t('v4/equipment_measures.edit.title')}
        variables={model.variable ? [model.variable] : []}
        editing
        o={o}
        {...props}
      />
    )}
  />
)

Edit.propTypes = {
  model: PropTypes.shape({
    id: PropTypes.number,
    variable: PropTypes.string
  }).isRequired
}

export default Edit
